import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { Breadcrumb, message, Modal, Pagination, Tabs } from 'antd';
import { request } from "@/utils/request"
import Config from "@/config/config";
import { formatTimestampToDate } from "@/utils/func";
import { ExclamationCircleOutlined, RightOutlined } from '@ant-design/icons';
import { APPOINTMENT_STATUS, APPOINTMENT_STATUS_NAME, ORDER_STATUS, ORDER_STATUS_NAME, PAYMENT_STATUS, REFOUND_AMOUNT_STATUS, REFOUND_AMOUNT_STATUS_NAME, REFOUND_DEPOSIT_STATUS, REFOUND_DEPOSIT_STATUS_NAME } from "@/constant";
import { useNavigate } from "react-router-dom";
import ErrorInfo from '@/assets/error_info.png'

export default function Order() {
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(12)
    const [total, setTotal] = useState(0)
    const [list, setList] = useState([])
    const [current_status, setCurrentStatus] = useState(-1)
    const logId = useRef('')
    const navigate = useNavigate()
    const items = [
        {
            key: '-1',
            label: '全部',
        },
        {
            key: '1',
            label: '未支付'
        },
        {
            key: '2',
            label: '待使用',
        },
        {
            key: '3',
            label: '未成交',
        },
        {
            key: '4',
            label: '已完成',
        },
    ];
    const getOrder = async (page, perPage, order_status = -1,) => {
        try {
            let url = 'restaurant/reservation_order_list' + `?page=${page}&per-page=${perPage}`;
            if (order_status) {
                url += "&order_status=" + order_status
            }
            const response = await request.get(url);
            let data = response.data
            setList(data)
            setTotal(response._meta.totalCount)
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    const pageChange = (e, v) => {
        console.log(e, v);
        setPage(e)
        setPerPage(v)
        getOrder(e, v);
    }
    useEffect(() => {
        getOrder(page, perPage, current_status);
    }, [page, perPage, current_status]);
    const sureCancel = () => {
        request.post('restaurant/reservation_order_cancel', { id: logId.current }).then(r => {
            message.success('取消成功')
            setTimeout(() => {
                getOrder(page, perPage, current_status);
            }, 500)
        })
    }
    const sureDel = () => {
        request.post('restaurant/reservation_order_delete', { id: logId.current }).then(r => {
            message.success('删除成功')
            setTimeout(() => {
                getOrder(page, perPage, current_status);
            }, 500)
        })
    }
    const sureRefound = () => {
        request.post('restaurant/reservation_order_refund_deposit', { id: logId.current }).then(r => {
            message.success('取消预约成功')
            setTimeout(() => {
                getOrder(page, perPage, current_status);
            }, 500)
        })
    }
    const cancelRefundDeposit = () => {
        refoundCancel.confirm({
            title: '撤回取消提示',
            icon: <ExclamationCircleOutlined />,
            content: '确定要撤回您已发起的取消预约申请吗？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                request.post('restaurant/reservation_order_cancel_refund_deposit', { id: logId.current }).then(r => {
                    message.success('取消预约已撤回')
                    setTimeout(() => {
                        getOrder(page, perPage, current_status);
                    }, 500)
                })
            },
            maskClosable: true,
        });

    }

    const [modalCancel, contextHolderCancel] = Modal.useModal();
    const confirmCancel = () => {
        modalCancel.confirm({
            title: '取消预约',
            icon: <ExclamationCircleOutlined />,
            content: '您确定要取消预约吗',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureCancel()
            },
            maskClosable: true,
        });
    };
    const [delCancel, contextHolderDel] = Modal.useModal();
    const confirmDel = () => {
        delCancel.confirm({
            title: '删除订单',
            icon: <ExclamationCircleOutlined />,
            content: '您确定要删除吗',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureDel()
            },
            maskClosable: true,
        });
    };
    const [refoundCancel, contextHolderRefound] = Modal.useModal();
    const confirmRefound = () => {
        refoundCancel.confirm({
            title: '取消预约',
            icon: <ExclamationCircleOutlined />,
            content: '餐厅已预约成功，取消预约将无法退预约费，您确定取消吗？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureRefound()
            },
            maskClosable: true,
        });
    };
    const submitPay = (id, order_no) => {
        navigate('/pay?id=' + id + '&sn=' + order_no + '&type=0&from=order')
    }
    return (
        <div className="order">
            {/* <NavigationBar></NavigationBar> */}
            <div className="order-title">
                <div className="order-title-box">
                    <Breadcrumb separator="">
                        {sessionStorage.getItem("mbx") === null && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'main' && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'canteen' && <Breadcrumb.Item href="/canteen">餐厅</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'transfer' && <Breadcrumb.Item href="/transfer">好位转让</Breadcrumb.Item>}
                        <Breadcrumb.Separator>
                            <RightOutlined />
                        </Breadcrumb.Separator>
                        <Breadcrumb.Item>预约订单</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>
            <div className="order-tab">
                <div className="order-tab-content">
                    <Tabs current={current_status} items={items} onChange={v => { setCurrentStatus(v) }} />
                </div>
            </div>
            <div className="order-content">
                <div className="order-content-net">
                    <div className="order-item-content">
                        {
                            list.map((item, index) => {
                                return (
                                    <div className="order-moudle" key={index} >
                                        {
                                            // 预约成功 押金退款中
                                            item.order_status == ORDER_STATUS.tobeUsed && item.appointment_status == APPOINTMENT_STATUS.success &&
                                            item.payment_status == PAYMENT_STATUS.paid &&
                                            <>
                                                {
                                                    (item.refund_deposit_status == REFOUND_DEPOSIT_STATUS.refunding || item.refund_deposit_status == REFOUND_DEPOSIT_STATUS.fail) ? <></>
                                                        : <div className="tips"><img src={ErrorInfo} className="icon"></img> <div>就餐完成后请点击就餐完成，需上传就餐凭证退押金</div></div>
                                                }

                                            </>
                                        }
                                        <div className="order-item" key={index} >

                                            <div className="order-top">

                                                <div className="order-code">
                                                    <div className="label">
                                                        预约号：
                                                    </div>
                                                    <div className="orderNum">
                                                        {item.reservation_code}
                                                    </div>
                                                </div>
                                                {
                                                    // 待支付
                                                    item?.order_status === ORDER_STATUS.waitPay
                                                    && <div className="status">{ORDER_STATUS_NAME[item?.order_status]}</div>
                                                }
                                                {
                                                    // 预约确认中
                                                    item.order_status == ORDER_STATUS.tobeUsed && item.appointment_status == APPOINTMENT_STATUS.confirming &&
                                                    item.payment_status == PAYMENT_STATUS.paid && <div className="status">预约确认中</div>
                                                }
                                                {
                                                    // 预约成功 押金退款中
                                                    item.order_status == ORDER_STATUS.tobeUsed && item.appointment_status == APPOINTMENT_STATUS.success &&
                                                    item.payment_status == PAYMENT_STATUS.paid &&
                                                    <>
                                                        {
                                                            (item.refund_deposit_status == REFOUND_DEPOSIT_STATUS.refunding || item.refund_deposit_status == REFOUND_DEPOSIT_STATUS.fail) ? <div className="status01">{REFOUND_DEPOSIT_STATUS_NAME[item.refund_deposit_status]?.name}</div>
                                                                : <div className="status">预约成功</div>
                                                        }

                                                    </>
                                                }
                                                {
                                                    // 未成交 预约失败 退全款
                                                    item?.order_status === ORDER_STATUS.notTransacted && item?.appointment_status == APPOINTMENT_STATUS.fail &&
                                                    <div className="status01">{REFOUND_AMOUNT_STATUS_NAME[item?.refund_amount_status]?.name}</div>
                                                }
                                                {/* 未成交 取消预约的展示 */}
                                                {
                                                    item?.order_status === ORDER_STATUS.notTransacted && item?.appointment_status == APPOINTMENT_STATUS.fail &&
                                                    (item.payment_status == PAYMENT_STATUS.unpaid || item.payment_status == PAYMENT_STATUS.fail) &&
                                                    <div className="status01">已取消</div>
                                                }
                                                {
                                                    // 未成交 预约成功之后 押金退款成功
                                                    item?.order_status === ORDER_STATUS.notTransacted &&
                                                    item.payment_status == PAYMENT_STATUS.paid &&
                                                    <>
                                                        {
                                                            item.refund_deposit_status == REFOUND_DEPOSIT_STATUS.success && <div className="status01">{REFOUND_DEPOSIT_STATUS_NAME[item.refund_deposit_status]?.name}</div>
                                                        }
                                                    </>
                                                }
                                                {
                                                    // 已完成
                                                    item?.order_status === ORDER_STATUS.completed && <div className="status">
                                                        {
                                                            item?.sub_status===9?'订单已结束':REFOUND_DEPOSIT_STATUS_NAME[item.refund_deposit_status]?.name
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            <div className="order-info" onClick={() => {
                                                navigate(`/orderDetail?id=${item.id}`)
                                            }}>
                                                <img className="order-cover" src={Config.imgPrefix + item?.restaurant_info?.cover[0]} alt="" />
                                                <div className="order-info-content">
                                                    <div className="order-info-title">
                                                        {item?.restaurant_info?.name}
                                                    </div>
                                                    {
                                                        // item.order_status == ORDER_STATUS.tobeUsed 
                                                        item.appointment_status == APPOINTMENT_STATUS.success ? <div className="order-info-time">预约成功时间：{item?.reservation_date_confirm} {item?.reservation_time_confirm}</div>
                                                            : <div className="order-info-time">预约时间：{formatTimestampToDate(item.reservation_date)} {item.reservation_time}</div>
                                                    }
                                                    <div className="order-info-time">
                                                        <div>预约人数：</div>
                                                        <div>{item.reservation_number}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="order-amount">
                                                合计<span style={{ color: '#C59D60' }}>￥{item.reservation_total_amount}</span>
                                            </div>
                                            {
                                                item.order_status == ORDER_STATUS.waitPay &&
                                                <div className="order-btns">
                                                    {/* 未支付 */}
                                                    <div className="order-btns-gray" onClick={(e) => {
                                                        e.stopPropagation()
                                                        logId.current = item.id
                                                        confirmCancel()
                                                    }}>取消预约</div>
                                                    {contextHolderCancel}
                                                    <div className="order-btns-active"
                                                        onClick={() => submitPay(item.id, item.reservation_code)}
                                                    >立即支付</div>
                                                </div>
                                            }
                                            {
                                                item.order_status == ORDER_STATUS.tobeUsed && item.appointment_status == APPOINTMENT_STATUS.success &&
                                                item.payment_status == PAYMENT_STATUS.paid &&
                                                <div className="order-btns">
                                                    {/* 预约成功 */}
                                                    <div>
                                                        {/* {convertDateToTimestamp(`${item.reservation_date_confirm} ${item.reservation_date_confirm}`)} */}
                                                    </div>
                                                    {
                                                        (
                                                            item.refund_deposit_status == REFOUND_DEPOSIT_STATUS.init
                                                            // || convertDateToTimestamp(`${item.reservation_date_confirm} ${item.reservation_time_confirm}`) < Math.floor(new Date().getTime() / 1000)
                                                        ) && <div className="order-btns-gray" onClick={(e) => {
                                                            e.stopPropagation()
                                                            logId.current = item.id
                                                            confirmRefound()
                                                        }}>取消预约</div>

                                                    }

                                                    {
                                                        item.refund_deposit_status == REFOUND_DEPOSIT_STATUS.refunding && <div className="order-btns-gray" onClick={(e) => {
                                                            e.stopPropagation()
                                                            logId.current = item.id
                                                            cancelRefundDeposit()
                                                        }}>撤回取消</div>
                                                    }

                                                    {
                                                        [0, 2, 3, 5].includes(item.refund_deposit_status) &&
                                                        <div className="order-btns-active" onClick={(e) => {
                                                            e.stopPropagation()
                                                            navigate(`/diningCompleted?id=${item.id}&type=1`)
                                                        }}>就餐完成</div>
                                                    }
                                                    {contextHolderRefound}
                                                </div>
                                            }
                                            {
                                                // 取消预约订单
                                                ((item?.order_status === ORDER_STATUS.notTransacted && item?.refund_deposit_status == REFOUND_DEPOSIT_STATUS.success) ||
                                                    ((item?.order_status === ORDER_STATUS.completed && item?.refund_deposit_status == REFOUND_DEPOSIT_STATUS.success)) ||
                                                    (item?.order_status === ORDER_STATUS.notTransacted && item?.refund_amount_status == REFOUND_AMOUNT_STATUS.success) ||
                                                    (item?.order_status === ORDER_STATUS.notTransacted && item?.appointment_status == APPOINTMENT_STATUS.fail))
                                                &&
                                                <div className="order-btns">
                                                    {/* 删除 */}
                                                    <div className="order-btns-gray" onClick={(e) => {
                                                        e.stopPropagation();
                                                        logId.current = item.id
                                                        confirmDel()
                                                    }}>删除订单</div>
                                                    {contextHolderDel}
                                                </div>
                                            }
                                        </div>
                                    </div>

                                )
                            })
                        }
                    </div>
                    {
                        !!list.length && <Pagination
                            className='main-pagination'
                            total={total}
                            pageSize={perPage}
                            pageSizeOptions={[12, 24, 36, 48]}
                            onChange={pageChange}
                            showQuickJumper
                            showTotal={(total) => `共${total}条`}
                            current={page}
                        />
                    }

                </div>

            </div>
        </div>
    );

}

